import { render } from "./ProviderCreate.vue?vue&type=template&id=6b4cb097&scoped=true"
import script from "./ProviderCreate.vue?vue&type=script&lang=js"
export * from "./ProviderCreate.vue?vue&type=script&lang=js"

import "./ProviderCreate.vue?vue&type=style&index=0&id=6b4cb097&scoped=true&lang=css"

import exportComponent from "C:\\frotend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b4cb097"]])

export default __exports__